import type { AnalyticsProvider } from '../types'
import { analyticsConfig } from '../config'

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
    dataLayer?: unknown[]
  }
}

class GA4Provider implements AnalyticsProvider {
  init(): void {
    // 스크립트는 index.html에서 이미 로드됨, 검증만 수행
    if (!window.gtag || !window.dataLayer) {
      if (analyticsConfig.debug) {
        console.warn('[GA4] Not available - gtag or dataLayer not found')
      }
      return
    }

    if (!analyticsConfig.ga4.measurementId) {
      if (analyticsConfig.debug) {
        console.warn('[GA4] Measurement ID not configured')
      }
      return
    }

    if (analyticsConfig.debug) {
      console.log('[GA4] Ready with ID:', analyticsConfig.ga4.measurementId)
      console.log('[GA4] dataLayer:', window.dataLayer)
    }
  }

  trackPageView(path: string, title?: string): void {
    if (!window.gtag) return

    window.gtag('event', 'page_view', {
      page_location: window.location.origin + path,
      page_path: path,
      page_title: title || document.title,
    })

    if (analyticsConfig.debug) {
      console.log('[GA4 Debug] Page View:', { path, title })
    }
  }

  trackEvent(eventName: string, parameters?: Record<string, unknown>): void {
    if (!window.gtag) return

    window.gtag('event', eventName, parameters)

    if (analyticsConfig.debug) {
      console.log('[GA4 Debug] Event:', eventName, parameters)
    }
  }

  setUserId(userId: string | null): void {
    if (!window.gtag) return

    if (userId) {
      window.gtag('config', analyticsConfig.ga4.measurementId, {
        user_id: userId,
      })
    } else {
      // Clear user_id
      window.gtag('config', analyticsConfig.ga4.measurementId, {
        user_id: undefined,
      })
    }

    if (analyticsConfig.debug) {
      console.log('[GA4 Debug] User ID:', userId)
    }
  }

  setUserProperties(properties: Record<string, unknown>): void {
    if (!window.gtag) return

    window.gtag('set', 'user_properties', properties)

    if (analyticsConfig.debug) {
      console.log('[GA4 Debug] User Properties:', properties)
    }
  }
}

export const ga4Provider = new GA4Provider()
